import { timeFormat } from '@/utils'
import Operate from './operate'

export default function () {
  return [
    {
      title: '家庭关系',
      [$field]: 'familyTies',
      width: 140,
      render: (h, {row}) => {
        return h('span', this.dictMap['BOE73'][row.familyTies])
      }
    },
    {
      title: '姓名',
      width: 200,
      [$field]: 'memberName'
    },
    {
      title: '性别',
      width: 100,
      [$field]: 'memberSex',
      render: (h, {row}) => {
        return h('span', this.dictMap['DM14'][row.memberSex])
      }
    },
    {
      title: '年龄',
      width: 100,
      [$field]: 'memberAge'
    },
    {
      title: '出生日期',
      width: 120,
      [$field]: 'birthday',
      render: (h, {row}) => {
        return h('span', row.birthday ? timeFormat(Number(row.birthday)) : '')
      }
    },
    // {
    //   title: '身份证号',
    //   [$field]: 'idCardNum'
    // },
    {
      title: '民族',
      width: 100,
      [$field]: 'nation',
      render: (h, {row}) => {
        return h('span', this.dictMap['DM15'][row.nation])
      }
    },
    {
      title: '健康状况',
      [$field]: 'familyMemberHealthy',
      render: (h, {row}) => {
        return h('span', this.dictMap['DM33'][row.familyMemberHealthy])
      }
    },
    // {
    //   title: '文化程度',
    //   [$field]: 'education',
    //   render: (h, {row}) => {
    //     return h('span', this.dictMap['DM16'][row.education])
    //   }
    // },
    // {
    //   title: '政治面貌',
    //   [$field]: 'political',
    //   render: (h, {row}) => {
    //     return h('span', this.dictMap['GB4762'][row.political])
    //   }
    // },
    // {
    //   title: '工作单位或学校',
    //   [$field]: 'workUnit',
    // },
    {
      title: '月平均收入',
      width: 160,
      [$field]: 'monthAvgIncome'
    },
    // {
    //   title: '联系电话',
    //   [$field]: 'phone'
    // },
    {
      'title': '操作',
      'width': 110,
      [$field]: 'operate',
      'isOperate': true,
      'slotComponent': Operate
    }
  ]
}
